import { useMemo } from 'react';

/**
 * Hook to generate search suggestions based on recipes and inventory
 * 
 * @param {Array} recipes - Array of recipe objects
 * @param {Array} inventory - Array of inventory ingredient objects
 * @param {string} searchInput - Current search input
 * @returns {Array} - Filtered search suggestions
 */
const useSearchSuggestions = (recipes, inventory, searchInput) => {
  const suggestions = useMemo(() => {
    // Build suggestions from inventory and recipes
    let result = [
      ...inventory.map(ing => ({ type: 'ingredient', id: ing.id, name: ing.name })),
      ...recipes.map(recipe => ({
        type: 'recipe',
        id: recipe.id,
        name: `${recipe.name} (${recipe.origin})`,
        rawName: recipe.name,
        origin: recipe.origin,
      })),
    ].filter(item => {
      const displayName = item.rawName || item.name;
      return displayName.toLowerCase().includes(searchInput.toLowerCase());
    });

    // Add "no matches" option if needed
    if (result.length === 0 && searchInput.trim() !== '') {
      result = [{ type: 'no-matches', id: 'no-matches', name: 'No matches found', disabled: true }];
    }

    return result;
  }, [recipes, inventory, searchInput]);

  return suggestions;
};

export default useSearchSuggestions; 